"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);






var _uuid = require('shared/services/uuid');
var _blobject = require('shared/services/blobject');
var _entity = require('shared/services/entity');

 const removeChatParticipant = async (
  entity,
  blobjectKey,
  conversationKey,
  myChatSubscriberKey,
) => {
  const userKeys = _entity.isEntityUser.call(void 0, entity)
    ? [entity.wrappedEntity.UserKey]
    : []

  const teamKeys = _entity.isEntityTeam.call(void 0, entity)
    ? [entity.wrappedEntity.TeamKey]
    : []

  const patientKeys = _entity.isEntityPatient.call(void 0, entity)
    ? [entity.wrappedEntity.PatientKey]
    : []

  const removedEntityUserKey = 'UserKey' in entity.wrappedEntity
    ? entity.wrappedEntity.UserKey
    : null
  const removedEntityTeamKey = 'TeamKey' in entity.wrappedEntity
    ? entity.wrappedEntity.TeamKey
    : null

  return _actions2.default.removeParticipantsFromChat({
    ConversationKey: conversationKey,
    UserKeys: userKeys,
    TeamKeys: teamKeys,
    PatientKeys: patientKeys,
  })
    .then(() => (
      removedEntityUserKey === myChatSubscriberKey ||
      removedEntityTeamKey === myChatSubscriberKey
    ) && _actions2.default.resumeLatestChat())
}; exports.removeChatParticipant = removeChatParticipant

// conversationKey is passed on so a team page opened from the chat can list
// the members of a team from another org that shares the chat, and chatKey so
// a person's page can load a participant from another org.
 const gotoParticipantPage = (
  subscribersMap,
  conversationKey,
  chatKey,
) =>
  (entity) =>
    _actions2.default.gotoEntityPage(
      entity,
      // SAFETY: the empty BLUID stands in for a missing org key, as before.
      _blobject.getSubscriberEntityOrgKey.call(void 0, subscribersMap, entity) || _uuid.EMPTY_BLUID ,
      _nullishCoalesce(conversationKey, () => ( undefined)),
      chatKey,
    ); exports.gotoParticipantPage = gotoParticipantPage
